export class TrackByIndex {
	trackByIndex(index: number): number {
		return index;
	}
}
